import React from 'react';
import { Progress, Typography } from 'antd';
import styles from '../../pages/Statistics/statistics.module.css';

const { Text } = Typography;

interface RateRowProps {
  label: string;
  value: number;
  caption?: string;
}

export const RateRow: React.FC<RateRowProps> = ({ label, value, caption }) => (
  <div className={styles.rateRow}>
    <div className={styles.rateHeader}>
      <Text type="secondary" style={{ fontSize: 12 }}>
        {label}
      </Text>
      <Text strong style={{ fontSize: 12 }}>
        {value.toFixed(2)}%
      </Text>
    </div>
    <Progress
      percent={Math.min(Math.max(value, 0), 100)}
      showInfo={false}
      size="small"
      className={styles.customProgress}
    />
    {caption && (
      <Text type="secondary" style={{ fontSize: 11 }}>
        {caption}
      </Text>
    )}
  </div>
);